<mat-form-field appearance="outline" [matTooltip]="tooltip" [matTooltipDisabled]="!tooltip" matTooltipPosition="above"
  matTooltipClass="sl-tooltip">

  <mat-label>
    {{label}} <app-required *ngIf="isRequired()"></app-required>
  </mat-label>

  <mat-select [formControl]="control" [multiple]="multiple" (ngModelChange)="emitChange($event)">
    <mat-option *ngIf="!multiple">Select {{label}}</mat-option>
    <mat-option *ngFor="let item of options" [value]="valueKey? item[valueKey]:item">
      {{optionKey? item[optionKey]: item}}
    </mat-option>
  </mat-select>

  <ng-container *ngIf="control && control.invalid" ngProjectAs="mat-error">
    <mat-error *ngIf="control.hasError('required')">
      {{label}} is <strong>required</strong>.
    </mat-error>
  </ng-container>

  <ng-container *ngIf="hint" ngProjectAs="mat-hint">
    <mat-hint>{{hint}}</mat-hint>
  </ng-container>
</mat-form-field>
